const DataTable = ({ columns, rows, loading, empty = "Nothing here yet.", rowKey = (r) => r.id }) => {
  if (loading) {
    return (
      <div className="space-y-2">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="h-9 animate-pulse rounded-lg bg-gray-50" />
        ))}
      </div>
    );
  }

  if (!rows.length) return <p className="py-2 text-sm text-gray-400">{empty}</p>;

  return (
    <div className="-mx-1 overflow-x-auto px-1">
      <table className="w-full min-w-[22rem]">
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                className={`border-b border-gray-100 pb-2 text-left text-[11px] font-semibold uppercase tracking-wider text-gray-400 ${col.className ?? ""}`}
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50">
          {rows.map((row) => (
            <tr key={rowKey(row)} className="transition-colors hover:bg-gray-50/70">
              {columns.map((col) => (
                <td key={col.key} className={`py-2.5 pr-4 last:pr-0 align-middle ${col.className ?? ""}`}>
                  {col.cell(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;